/**
 * Calculates a person's age in years based on their date of birth.
 *
 * @param dob - The date of birth as a Date object
 * @returns The age in complete years (integer)
 *
 * @example
 * ```typescript
 * const birthDate = new Date('1990-05-15');
 * const age = getAge(birthDate);
 * console.log(age); // e.g., 34 (as of 2024)
 * ```
 *
 * @remarks
 * - Returns the number of complete years lived
 * - Accounts for whether the person has had their birthday this year
 * - Returns 0 for future dates of birth
 */
export const getAge = (dob: Date): number => {
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  // If birthday hasn't occurred yet this year, subtract 1
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  // Return 0 for future dates
  return Math.max(0, age);
};
